module.exports = __webpack_public_path__ + "static/img/yizhidao.96bb96c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yizhidao.png
// module id = /cYn
// module chunks = 1